import {Component, Input} from '@angular/core';

@Component({
    selector: 'wba-fragezeichen',
    templateUrl: './fragezeichen.component.html',
    styleUrls: ['./fragezeichen.component.scss'],
    standalone: false
})
export class FragezeichenComponent{

  @Input() dataTarget: string;
  @Input() dataModal = 'modal';
  @Input() label = '';
  @Input() inline = false;
  @Input() dataAnalyticsName = '';
  @Input() smaller = false;

}
